var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image-product image__wrapper"},[_c('image-spinner',{staticClass:"image__spinner"}),_c('img',{staticClass:"image__item",style:(_vm.styleObject),attrs:{"loading":"lazy","data-url":_vm.source,"alt":". . ."}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }